import { request } from "@/utils/request";

/**
 * 根据国内HSCode查国外税率
 * @param {Object} params 查询参数
 * @param {string} params.htsno HTS编码（前缀模糊匹配）
 * @returns {Promise} 返回Promise对象
 */
export function queryTariffHts(params) {
    return request("/data/hts/query", "get", params);
}
